'use client'

import { type AxiosError } from 'axios'
import useSwr, { mutate, type SWRResponse } from 'swr'

import {
  AccountControllerV2ApiFactory,
  type UserOrderResponseV2,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../api'
import { useGlobalConfigContext } from '../../global-config'

const LAST_ORDER_KEY = 'lastOrder'

export const useApiOrdersSwrGetLastOrder = (): SWRResponse<
  UserOrderResponseV2,
  AxiosError
> => {
  const config = useGlobalConfigContext()
  const client = useGlooApi(AccountControllerV2ApiFactory)
  const fetcher = async (): Promise<UserOrderResponseV2> => {
    const response = await client.accountV2TenantLanguageLastOrderGet({
      language: config.language,
      tenant: config.tenantAndEnv,
    })

    return response.data
  }

  return useSwr(LAST_ORDER_KEY, fetcher)
}

export const refetchUseApiOrdersSwrGetLastOrder = async (): Promise<
  UserOrderResponseV2 | undefined
> => {
  return mutate<UserOrderResponseV2>(LAST_ORDER_KEY)
}
